import {combineReducers} from "redux";
import {ThemeReducer} from "./theme";
import {ThemeState} from "@/configs/ThemeConfig";
import {ActionReducer} from "./action";
import {ActionState} from "@/configs/ActionConfig";

export const reducers = combineReducers({
    theme: ThemeReducer,
    action: ActionReducer
});
export interface RootState {
    theme: ThemeState,
    action: ActionState
}
